import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';
import { fg } from '@atlaskit/platform-feature-flags/fg';

const MULTI_SITE_SEARCH_PRODUCTS = ['confluence', 'jira'];

type FpsMultiSiteSearchCohort = 'control' | 'test-1' | 'test-2';

/**
 * Multi-site search cohort for the current session. Control searches only the current site;
 * test-1 uses the current selection defaults; test-2 will select sites by default.
 */
export const serveFpsMultiSiteSearchExperiment = ({
	primaryProduct,
	fireExperimentExposure = true,
}: {
	fireExperimentExposure?: boolean;
	primaryProduct?: string | null;
} = {}): FpsMultiSiteSearchCohort => {
	if (
		!primaryProduct ||
		!MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct) ||
		!fg('rovo_fps_enable_multi_site_search')
	) {
		return 'control';
	}

	// Non-exposing callers derive configuration; the UI fires exposure when serving the selector.
	const getCohort = fireExperimentExposure ? expVal : UNSAFE_expValNoExposure;
	const cohort = getCohort('rovo_fps_multi_site_search_exp', 'cohort', 'control');

	// Preserve existing assignments while the experiment config migrates to test-1.
	if (cohort === 'test' || cohort === 'test-1') {
		return 'test-1';
	}

	return cohort === 'test-2' ? 'test-2' : 'control';
};
